import * as React from 'react';
import { ArrowRight } from 'lucide-react';

import { Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbSeparator } from '@/components/ui/breadcrumb';

type SegmentLikeProps = {
    separator?: 'chevron' | 'arrow';
};

export const PageBreadcrumb = ({ children }: { children: React.ReactNode }) => {
    const segments = React.Children.toArray(children).filter((child): child is React.ReactElement<SegmentLikeProps> =>
        React.isValidElement(child),
    );

    return (
        <Breadcrumb data-test="page-breadcrumb">
            <BreadcrumbList>
                {segments.map((segment, index) => (
                    <React.Fragment key={index}>
                        {index > 0 ? (
                            <BreadcrumbSeparator>
                                {segment.props.separator === 'arrow' ? (
                                    <ArrowRight className="size-2.5 opacity-50" strokeWidth={1.25} />
                                ) : undefined}
                            </BreadcrumbSeparator>
                        ) : null}
                        <BreadcrumbItem>{segment}</BreadcrumbItem>
                    </React.Fragment>
                ))}
            </BreadcrumbList>
        </Breadcrumb>
    );
};
